import { DEFAULT_I18N_LANGUAGE, I18N_LANGUAGE_ALIASES } from './constants';
import type { I18nLanguage } from './types';

const normalizeLanguage = (language: string) => {
  return language.trim().toLowerCase();
};

export const resolveLanguage = (language: string | null | undefined): I18nLanguage => {
  if (!language) {
    return DEFAULT_I18N_LANGUAGE;
  }

  return I18N_LANGUAGE_ALIASES[normalizeLanguage(language)] ?? DEFAULT_I18N_LANGUAGE;
};
